import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import ApiConstants from "../constants/api-constants";

interface ReCaptchaProps {
  onChange: (value: string | null) => void;
}

const ReCaptchaComponent: React.FC<ReCaptchaProps> = ({ onChange }) => {
  const handleCaptchaChange = (value: string | null) => {
    console.log("recaptcha value", value);
    onChange(value);
  };

  return (
    <ReCAPTCHA
      sitekey={ApiConstants.RECAPTCHA_KEY}
      onChange={handleCaptchaChange}
    />
  );
};

export default ReCaptchaComponent;
